import { useEffect, useState } from "react";
import { ratingsAPI } from "../services/api";
import { Star } from "lucide-react";

export default function Ratings() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ratingsAPI.leaderboard()
      .then(r => setLeaderboard(r.data.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const stars = (n) => Array.from({ length: 5 }, (_, i) => (
    <span key={i} style={{ color: i < Math.round(n) ? "var(--accent)" : "var(--border2)" }}>★</span>
  ));

  return (
    <div>
      <style>{`
        .ratings-mobile-cards  { display: none; }
        .ratings-desktop-table { display: block; }
        .rating-card {
          padding: 14px 16px;
          border-bottom: 1px solid var(--border);
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .rating-card:last-child { border-bottom: none; }
        @media (max-width: 640px) {
          .ratings-mobile-cards  { display: block; }
          .ratings-desktop-table { display: none; }
        }
      `}</style>

      <div className="page-header">
        <div>
          <div className="page-title">Ratings</div>
          <div className="page-subtitle">Rider performance leaderboard</div>
        </div>
      </div>

      <div className="card">
        {loading ? <div className="loading-center"><div className="spinner"/><span>Loading...</span></div> : (
          <>
            {/* Mobile cards */}
            <div className="ratings-mobile-cards">
              {leaderboard.length === 0
                ? <div className="empty-state"><Star size={40}/><p>No ratings yet</p></div>
                : leaderboard.map((r, i) => (
                <div key={i} className="rating-card">
                  <span style={{fontWeight:700,fontSize:22,width:32,textAlign:"center",flexShrink:0,color:i===0?"var(--accent)":i===1?"#c0c0c0":i===2?"#cd7f32":"var(--text3)"}}>
                    {i===0?"🥇":i===1?"🥈":i===2?"🥉":`#${i+1}`}
                  </span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:700,fontSize:14}}>{r.name}</div>
                    <div style={{fontSize:12,color:"var(--text3)",textTransform:"capitalize"}}>{r.vehicle_type||"—"} · {r.total_deliveries} deliveries</div>
                    <div style={{fontSize:14,letterSpacing:1,marginTop:2}}>{stars(r.rating)}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{color:"var(--accent)",fontWeight:700,fontFamily:"DM Mono",fontSize:16}}>
                      {parseFloat(r.rating||0).toFixed(2)}
                    </div>
                    <div style={{fontSize:11,color:"var(--text3)"}}>rating</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop table */}
            <div className="ratings-desktop-table table-wrap">
              <table>
                <thead><tr><th>Rank</th><th>Rider</th><th>Vehicle</th><th>Total Deliveries</th><th>Rating</th><th>Stars</th></tr></thead>
                <tbody>
                  {leaderboard.length === 0
                    ? <tr><td colSpan={6}><div className="empty-state"><Star size={40}/><p>No ratings yet</p></div></td></tr>
                    : leaderboard.map((r, i) => (
                    <tr key={i}>
                      <td style={{ fontWeight:700, color: i===0?"var(--accent)":i===1?"#c0c0c0":i===2?"#cd7f32":"var(--text3)" }}>
                        {i===0?"🥇":i===1?"🥈":i===2?"🥉":`#${i+1}`}
                      </td>
                      <td className="fw-bold">{r.name}</td>
                      <td style={{textTransform:"capitalize",color:"var(--text2)"}}>{r.vehicle_type||"—"}</td>
                      <td className="mono">{r.total_deliveries}</td>
                      <td style={{color:"var(--accent)",fontWeight:700,fontFamily:"DM Mono"}}>
                        {parseFloat(r.rating||0).toFixed(2)}
                      </td>
                      <td style={{fontSize:16,letterSpacing:1}}>{stars(r.rating)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}